import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConstantsHelper } from '../../../helpers/constants.helper';

@Component({
  standalone: false,
  selector: 'app-add-shipping-method',
  templateUrl: 'add-shipping-method.component.html',
  styleUrls: ['../modal.component.scss'],
})

export class AddShippingMethodComponent implements OnInit {
  form!: FormGroup;
  shippingMethodOptions: Array<string> = [];
  @Output() readonly responseChanged = new EventEmitter();

  constructor(private fb: FormBuilder,
              private constantsHelper: ConstantsHelper
  ) {
    this.shippingMethodOptions = this.constantsHelper.getShippingMethodOptions();
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      shippingMethod: ['', Validators.required],
    });
  }

  emitTrue(): void {
    this.responseChanged.emit(this.form.value);
  }

  emitFalse(): void {
    this.responseChanged.emit(null);
  }
}